/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetFollowUpPromptSetting200Response } from '../models';
// @ts-ignore
import { GetTranscriptionSummaryPromptSetting200Response } from '../models';
// @ts-ignore
import { PutTranscriptionSummaryPromptSettingRequest } from '../models';
/**
 * PromptSettingApi - axios parameter creator
 * @export
 */
export const PromptSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * FollowUpプロンプト設定取得API
         * @summary FollowUpプロンプト設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpPromptSetting: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/prompt_settings/follow_up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 文字起こし要約プロンプト設定取得API
         * @summary 文字起こし要約プロンプト設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptionSummaryPromptSetting: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/prompt_settings/transcription_summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * FollowUpプロンプト設定更新API
         * @summary FollowUpプロンプト設定更新API
         * @param {GetFollowUpPromptSetting200Response} [getFollowUpPromptSetting200Response] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFollowUpPromptSetting: async (getFollowUpPromptSetting200Response?: GetFollowUpPromptSetting200Response, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/prompt_settings/follow_up`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getFollowUpPromptSetting200Response, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 文字起こし要約プロンプト設定更新API
         * @summary 文字起こし要約プロンプト設定更新API
         * @param {PutTranscriptionSummaryPromptSettingRequest} [putTranscriptionSummaryPromptSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTranscriptionSummaryPromptSetting: async (putTranscriptionSummaryPromptSettingRequest?: PutTranscriptionSummaryPromptSettingRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/user/prompt_settings/transcription_summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(putTranscriptionSummaryPromptSettingRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PromptSettingApi - functional programming interface
 * @export
 */
export const PromptSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PromptSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * FollowUpプロンプト設定取得API
         * @summary FollowUpプロンプト設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFollowUpPromptSetting(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetFollowUpPromptSetting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFollowUpPromptSetting(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 文字起こし要約プロンプト設定取得API
         * @summary 文字起こし要約プロンプト設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTranscriptionSummaryPromptSetting(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetTranscriptionSummaryPromptSetting200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTranscriptionSummaryPromptSetting(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * FollowUpプロンプト設定更新API
         * @summary FollowUpプロンプト設定更新API
         * @param {GetFollowUpPromptSetting200Response} [getFollowUpPromptSetting200Response] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putFollowUpPromptSetting(getFollowUpPromptSetting200Response?: GetFollowUpPromptSetting200Response, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putFollowUpPromptSetting(getFollowUpPromptSetting200Response, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 文字起こし要約プロンプト設定更新API
         * @summary 文字起こし要約プロンプト設定更新API
         * @param {PutTranscriptionSummaryPromptSettingRequest} [putTranscriptionSummaryPromptSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putTranscriptionSummaryPromptSetting(putTranscriptionSummaryPromptSettingRequest?: PutTranscriptionSummaryPromptSettingRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putTranscriptionSummaryPromptSetting(putTranscriptionSummaryPromptSettingRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PromptSettingApi - factory interface
 * @export
 */
export const PromptSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PromptSettingApiFp(configuration)
    return {
        /**
         * FollowUpプロンプト設定取得API
         * @summary FollowUpプロンプト設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFollowUpPromptSetting(options?: any): AxiosPromise<GetFollowUpPromptSetting200Response> {
            return localVarFp.getFollowUpPromptSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * 文字起こし要約プロンプト設定取得API
         * @summary 文字起こし要約プロンプト設定取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTranscriptionSummaryPromptSetting(options?: any): AxiosPromise<GetTranscriptionSummaryPromptSetting200Response> {
            return localVarFp.getTranscriptionSummaryPromptSetting(options).then((request) => request(axios, basePath));
        },
        /**
         * FollowUpプロンプト設定更新API
         * @summary FollowUpプロンプト設定更新API
         * @param {GetFollowUpPromptSetting200Response} [getFollowUpPromptSetting200Response] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putFollowUpPromptSetting(getFollowUpPromptSetting200Response?: GetFollowUpPromptSetting200Response, options?: any): AxiosPromise<void> {
            return localVarFp.putFollowUpPromptSetting(getFollowUpPromptSetting200Response, options).then((request) => request(axios, basePath));
        },
        /**
         * 文字起こし要約プロンプト設定更新API
         * @summary 文字起こし要約プロンプト設定更新API
         * @param {PutTranscriptionSummaryPromptSettingRequest} [putTranscriptionSummaryPromptSettingRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putTranscriptionSummaryPromptSetting(putTranscriptionSummaryPromptSettingRequest?: PutTranscriptionSummaryPromptSettingRequest, options?: any): AxiosPromise<void> {
            return localVarFp.putTranscriptionSummaryPromptSetting(putTranscriptionSummaryPromptSettingRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PromptSettingApi - interface
 * @export
 * @interface PromptSettingApi
 */
export interface PromptSettingApiInterface {
    /**
     * FollowUpプロンプト設定取得API
     * @summary FollowUpプロンプト設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptSettingApiInterface
     */
    getFollowUpPromptSetting(options?: AxiosRequestConfig): AxiosPromise<GetFollowUpPromptSetting200Response>;

    /**
     * 文字起こし要約プロンプト設定取得API
     * @summary 文字起こし要約プロンプト設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptSettingApiInterface
     */
    getTranscriptionSummaryPromptSetting(options?: AxiosRequestConfig): AxiosPromise<GetTranscriptionSummaryPromptSetting200Response>;

    /**
     * FollowUpプロンプト設定更新API
     * @summary FollowUpプロンプト設定更新API
     * @param {GetFollowUpPromptSetting200Response} [getFollowUpPromptSetting200Response] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptSettingApiInterface
     */
    putFollowUpPromptSetting(getFollowUpPromptSetting200Response?: GetFollowUpPromptSetting200Response, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * 文字起こし要約プロンプト設定更新API
     * @summary 文字起こし要約プロンプト設定更新API
     * @param {PutTranscriptionSummaryPromptSettingRequest} [putTranscriptionSummaryPromptSettingRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptSettingApiInterface
     */
    putTranscriptionSummaryPromptSetting(putTranscriptionSummaryPromptSettingRequest?: PutTranscriptionSummaryPromptSettingRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for putFollowUpPromptSetting operation in PromptSettingApi.
 * @export
 * @interface PromptSettingApiPutFollowUpPromptSettingRequest
 */
export interface PromptSettingApiPutFollowUpPromptSettingRequest {
    /**
     * 
     * @type {GetFollowUpPromptSetting200Response}
     * @memberof PromptSettingApiPutFollowUpPromptSetting
     */
    readonly getFollowUpPromptSetting200Response?: GetFollowUpPromptSetting200Response
}

/**
 * Request parameters for putTranscriptionSummaryPromptSetting operation in PromptSettingApi.
 * @export
 * @interface PromptSettingApiPutTranscriptionSummaryPromptSettingRequest
 */
export interface PromptSettingApiPutTranscriptionSummaryPromptSettingRequest {
    /**
     * 
     * @type {PutTranscriptionSummaryPromptSettingRequest}
     * @memberof PromptSettingApiPutTranscriptionSummaryPromptSetting
     */
    readonly putTranscriptionSummaryPromptSettingRequest?: PutTranscriptionSummaryPromptSettingRequest
}

/**
 * PromptSettingApi - object-oriented interface
 * @export
 * @class PromptSettingApi
 * @extends {BaseAPI}
 */
export class PromptSettingApi extends BaseAPI implements PromptSettingApiInterface {
    /**
     * FollowUpプロンプト設定取得API
     * @summary FollowUpプロンプト設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptSettingApi
     */
    public getFollowUpPromptSetting(options?: AxiosRequestConfig) {
        return PromptSettingApiFp(this.configuration).getFollowUpPromptSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 文字起こし要約プロンプト設定取得API
     * @summary 文字起こし要約プロンプト設定取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptSettingApi
     */
    public getTranscriptionSummaryPromptSetting(options?: AxiosRequestConfig) {
        return PromptSettingApiFp(this.configuration).getTranscriptionSummaryPromptSetting(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * FollowUpプロンプト設定更新API
     * @summary FollowUpプロンプト設定更新API
     * @param {PromptSettingApiPutFollowUpPromptSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptSettingApi
     */
    public putFollowUpPromptSetting(requestParameters: PromptSettingApiPutFollowUpPromptSettingRequest = {}, options?: AxiosRequestConfig) {
        return PromptSettingApiFp(this.configuration).putFollowUpPromptSetting(requestParameters.getFollowUpPromptSetting200Response, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 文字起こし要約プロンプト設定更新API
     * @summary 文字起こし要約プロンプト設定更新API
     * @param {PromptSettingApiPutTranscriptionSummaryPromptSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromptSettingApi
     */
    public putTranscriptionSummaryPromptSetting(requestParameters: PromptSettingApiPutTranscriptionSummaryPromptSettingRequest = {}, options?: AxiosRequestConfig) {
        return PromptSettingApiFp(this.configuration).putTranscriptionSummaryPromptSetting(requestParameters.putTranscriptionSummaryPromptSettingRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
